import {
  Component,
  OnInit,
  OnDestroy,
  NgZone
} from '@angular/core';
import {
  getMonth,
  getDay,
  getYear
} from 'date-fns';

import { Router } from '@angular/router';
import { DetailsModel, DetailsStoreModel, DetailsFormModel } from './details.model';
import DetailsForm from './details.form';
import { MatDialog } from '@angular/material';
import { ErrorComponent } from '../popups/error/error.component';
import { Store } from '@ngrx/store';

import { State } from '../../reducers/index';
import { SHOW_HEADER, OVERLAY_START } from '../../actions/header.action';
import { Info, INFO_UPDATE } from '../../actions/info.action';
import { Booking } from '../../actions/booking.action';
import { Registration, REGISTRATION_REQUEST } from '../../actions/registration.action';

@Component({
  selector: 'consentz-details',
  templateUrl: './details.template.html',
  styleUrls: ['./details.styles.scss']
})
export class DetailsComponent implements OnInit, OnDestroy {
  private model: DetailsModel = new DetailsModel(
    JSON.parse(localStorage.getItem('currentBookingOptions')),
    localStorage.getItem('AppId') ? localStorage.getItem('AppId') : window.location.hash.split('/')[1]
  );
  private storeData: DetailsStoreModel = new DetailsStoreModel();
  private form: DetailsForm;
  public dayMax: any = {
    year: getYear(new Date),
    month: getMonth(new Date),
    day: getDay(new Date)
  };

  constructor(
    public dialog: MatDialog,
    private store: Store<State>,
    private zone: NgZone,
    private router: Router
  ) {
    // show header, create form, subscribtion on widget options and local selections
    this.store.dispatch({ type: SHOW_HEADER });
    this.form = new DetailsForm(new DetailsFormModel());
    this.storeData.subscribtion.info$ = store.select<any>('info').subscribe((data: Info) => {
      this.model.currentInfoData = data;
    });
    this.storeData.subscribtion.booking$ = store.select<any>('booking').subscribe((data: Booking) => {
      if (Object.keys(data).find(key => key === 'primaryFontColour')) {
        this.model.currentBookingOptions = data;
      }
    });
  }
  // open angular material dialog
  public openDialog(message): void {
    const dialogRef = this.dialog.open(ErrorComponent, {
      width: '90%',
      data: message,
    });
  }
  public openPicker(event: any, datePickerRef: any): void {
    event.stopPropagation();
    datePickerRef.toggle();
    if (this.form.model.birthday.getTime() === new Date(1900, 0, 1).getTime()) {
      datePickerRef.navigateTo({ year: 2000, month: 1 });
       const getTimeZone = () => {
          const offset = new Date().getTimezoneOffset();
          const o = Math.abs(offset);
          return {
            sing: (offset < 0 ? '+' : '-'),
            minutes: +('00' + (o % 60)).slice(-2),
            hours: +('00' + Math.floor(o / 60)).slice(-2)
          };
        };
      this.form.formGroup.patchValue({
        date: new Date(2000, 0, 1, getTimeZone().hours, getTimeZone().minutes)
      });
    }
  }
  // start registration with saving data to store
  public registration(): void {
    this.model.currentInfoData.details = this.form.model;
    delete this.model.currentInfoData.details.passwordConfirm;
    this.store.dispatch({
      type: INFO_UPDATE,
      payload: this.model.currentInfoData
    });
    this.store.dispatch({ type: OVERLAY_START });
    this.store.dispatch({
      type: REGISTRATION_REQUEST,
      payload: this.model.currentInfoData.details
    });
  }
  // subscribtion for registration
  public ngOnInit(): void {
    this.storeData.subscribtion.registration$ = this.store.select<any>('registration').subscribe((data: Registration) => {
      if (data['error']) {
        this.openDialog({
          status: 'Error',
          message: 'You enter invalid data. Please, check it and try again.',
          type: 'registration'});
      }
    });
  }
  // unsubscribe from store
  public ngOnDestroy(): void {
    this.storeData.subscribtion.info$.unsubscribe();
    this.storeData.subscribtion.booking$.unsubscribe();
    this.storeData.subscribtion.registration$.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /Users/dtrubetskoi/Desktop/projects/online-booking-widget/src/app/components/details/details.component.ts